import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { AppLink } from 'lib/app/app-link';
import { TrackingLink } from 'lib/app/tracking-link';
import { CdnImagePath } from 'lib/cdn-image-path';
import LocaleContext from 'lib/locale-context';
import usePlatform, { PlatformType } from 'lib/use-platform';

import { onClickAboutCTA } from 'containers/events';

import PageSectionCta from 'components/page/sections/page-section-cta';

export const ComplimentsBlockOneContainer: FunctionComponent = () => {
    const lang = React.useContext(LocaleContext);

    const imagePath = `${CdnImagePath}/bumble/l-assets/${lang}/features/Compliments-HowComplimentFeaturesWork.jpg`;

    const platform = usePlatform();
    const ctaLink: { [key in PlatformType]: string } = {
        [PlatformType.ios]: TrackingLink.APP_STORE_IOS,
        [PlatformType.android]: TrackingLink.GOOGLE_PLAY_STORE,
        [PlatformType.ie11]: AppLink.BUMBLE_GET_STARTED,
        [PlatformType.edge]: AppLink.BUMBLE_GET_STARTED,
        [PlatformType.unknown]: AppLink.BUMBLE_GET_STARTED,
    };

    const props = {
        imagePosition: 'left',
        imageSrc: imagePath,
        imageObjectPosition: '33% 31%',
        imageAlt: '',
        title: features.compliments.lxComplimentsOneBlockTitle,
        text: features.compliments.lxComplimentsOneBlockBodyText,
        actionText: features.compliments.lxFeaturesDownloadBumbleCta,
        actionUrl: ctaLink[platform],
    };

    return (
        <PageSectionCta
            title={props.title}
            /**
             * Fix language based code
             */
            // titleLang={'en'}
            text={props.text}
            action={{
                text: props.actionText,
                href: props.actionUrl,
                onClick: onClickAboutCTA,
            }}
            image={{
                src: props.imageSrc,
                objectPosition: props.imageObjectPosition,
                inlinePosition: 'start',
            }}
            color="yellow"
        />
    );
};
